import React, { useState,useRef } from "react";
import  { TimePeriods, Service }  from '../constant/data'
import { ToastContainer, toast } from 'react-toastify';
import { useForm } from "react-hook-form";
import emailjs from '@emailjs/browser';
import 'react-toastify/dist/ReactToastify.css';
import { PopupWidget } from "react-calendly";
import { Helmet } from 'react-helmet-async'

function Pricing() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        company: "",
        city: "",
        state: "",
        country: "",
        phone: "",
        trainings: "",
        service: "",
        customRequest: "",
        // file: "",
        timePeriods: "",
        message: "",
      });
      const [isLoading, setIsLoading] = useState(false);
      const form = useRef(null);
    
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
      };
    
      const sendEmail = async (e) => {
        e.preventDefault();
        setIsLoading(true);
    
        try {
          // Create a FormData object and populate it with form data
          const formDataObject = new FormData(form.current);
    
          // Map the FormData to the state object
          const data = {};
          formDataObject.forEach((value, key) => {
            data[key] = value;
          });
          setFormData(data);
    
          // Send the email using EmailJS
          const result = await emailjs.sendForm(
            "service_qsvlxdd",
            "template_3tp0qzq",
            form.current,
            "GgcIHmOChlLGj8Btr"
          );
    
          toast.success("Thank you for your request! We will get back to you soon.", {
           
          });
    
          console.log("Email sent:", result.text);
    
          setFormData({
            name: "",
            email: "",
            company: "",
            city: "",
            state: "",
            country: "",
            phone: "",
            trainings: "",
            service: "",
            customRequest: "",
            // file: "",
            timePeriods: "",
            message: "",
          });
   
        } catch (error) {
          toast.error("An error occurred while sending your request. Please try again.");
          console.error("Email sending error:", error);
        } finally {
          setIsLoading(false);
        }
      };

  return (
    <>
      <Helmet>
                <title> NagsPro-Pricing</title>
                 <meta name="description" content="At NagsPro, we offer competitive and transparent pricing tailored to meet your specific needs. Our goal is to provide exceptional value while ensuring the highest quality services"/>
                  <link rel="canonical" href="/Pricing"/>
                   </Helmet>
 
    <div>
        <ToastContainer/>
          <div className="container-fluid bg-primary py-5 mb-5 hero-header">
    <div className="container py-5">
      <div className="row justify-content-center py-5">
        <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
          <h1 className="display-3 text-white animated slideInDown">
          Request Pricing Information
          </h1>
        
        </div>
      </div>
    </div>
  </div>
      {/* Package Start */}
   

<div className="form-container">
      <h2>Request Pricing Information</h2>
      <form ref={form} onSubmit={sendEmail} className="pricing-form">
        <div className="form-group">
          <label htmlFor="name">Full Name</label>
          <input
            type="text"
            id="name"
            name="name"
            placeholder="Enter your full name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Enter your email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="company">Company Name ( if any)</label>
          <input
            type="text"
            id="company"
            name="company"
            placeholder="Enter your company name"
            value={formData.company}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="company">City</label>
          <input
            type="text"
            id="city"
            name="city"
            placeholder="Enter your city"
            value={formData.city}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="company">State</label>
          <input
            type="text"
            id="state"
            name="state"
            placeholder="Enter your state"
            value={formData.state}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="company">Country</label>
          <input
            type="text"
            id="country"
            name="country"
            placeholder="Enter your country"
            value={formData.country}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="phone">Phone Number </label>
          <input
            type="tel"
            id="phone"
            name="phone"
            placeholder="+1XXXXXXXXX"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>
     
        <div className="form-group">
          <label htmlFor="service">Have you attended any I.T trainings or taken any certification exam in the past?</label>
          <select
            id="trainings"
            name="trainings"
            value={formData.trainings}
            onChange={handleChange}
            required
          >
            <option value="" disabled>
              -- Select Option --
            </option>
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="service">Select Service (Certification/Training of Interest)</label>
          <select
            id="service"
            name="service"
            value={formData.service}
            onChange={handleChange}
            required
          >
            <option value="" disabled>
              -- Select a Service --
            </option>
                {Service.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
          </select>
        </div>

        {formData.service === "custom-request" && (
          <div className="form-group">
            <label htmlFor="customRequest">Custom Request Details</label>
            <textarea
              id="customRequest"
              name="customRequest"
              placeholder="Provide details for your custom request"
              value={formData.customRequest}
              onChange={handleChange}
              required
            />
          </div>
        )}

{/* <div className="form-group">
          <label htmlFor="company">File Link ( if any)</label>
          <input
            type="text"
            id="file"
            name="file"
            placeholder="Paste your file link"
            value={formData.file}
            onChange={handleChange}
          />
        </div> */}

<div className="form-group">
  <label htmlFor="timePeriods">
    If given a chance to select a time for your classes, what periods of the day best work for you? Select below all periods that work best for you. Please note that NagsPro has a designated timing for our classes however the information you are providing here will help our data collection for the most popular periods. Check all that applies to you, all timing are in EST.
  </label>

            <select
                id="timePeriods"
                name="timePeriods"
                // multiple
                className="form-control py-2 w-2 appearance-none"
              >
                <option value="">Select TimeFrame</option>
                {TimePeriods.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
           
</div>



             
        <div className="form-group">
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            name="message"
            placeholder="Write any specific details or questions"
            value={formData.message}
            onChange={handleChange}
          />
        </div>
        <button type="submit" className="submit-btn" disabled={isLoading}>
        {isLoading ? "Sending..." : "Submit"}
        </button>
      </form>
    </div>

    {/* Package End */}
    <PopupWidget
                    url="https://calendly.com/nagspros"
                    rootElement={document.getElementById('root')}
                    text="Schedule a Consultation!"
                    textColor="#ffffff"
                    color="#346815FF"
                />
    </div>
    </>
  )
}

export default Pricing